import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

export default function MediaCard(props) {
    return (
        <Card sx={{ minWidth: {md:345, xs: 290}, maxWidth: 345}}>
            <CardMedia
                sx={{ height: 140 }}
                image={props.image}
                title={props.title}
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    {props.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {props.description}
                </Typography>
            </CardContent>
            <CardActions>
                <Link to={props.link}>
                    <Button
                        variant="contained"
                        sx={{ mr: 1, bgcolor: '#a30fee', ':hover': { bgcolor: '#8119d1' } }}
                    >
                        Open
                    </Button>
                </Link>
            </CardActions>
        </Card>
    );
}